import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {AppDialogService, AppDrawerService} from '@app/theme';
import {Subscription} from 'rxjs';
import {VersionService} from '../../../shared/version.service';

@Component({
	standalone: false,
	selector: 'ngx-footer',
	styleUrls: ['./footer.component.scss'],
	template: `
		<span class="created-by">
      Created with ♥ by le 17.45 - {{ getVersion() }}
    </span>
		<div class="socials">
			<ngx-lang-picker></ngx-lang-picker>
			<a href="https://facebook.com/le17.45" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><i class="pi pi-facebook" aria-hidden="true"></i></a>
			<a href="mailto:contact@le17-45.fr" aria-label="Email"><i class="pi pi-envelope" aria-hidden="true"></i></a>
		</div>
		<ng-template #dialog let-data let-ref="dialogRef">
			<p-card>
				<ng-template pTemplate="header" translate>Nouvelle version disponible !</ng-template>
				<div translate>Nous venons de déployer une nouvelle version de l'application, veuillez recharger votre
				              page.
				</div>
				<ng-template pTemplate="footer">
					<p-button (onClick)="ref.close()" severity="success" translate>Recharger</p-button>
				</ng-template>
			</p-card>
		</ng-template>
	`,
})
export class FooterComponent implements OnInit, OnDestroy {
	public version: string;
	@ViewChild('dialog') dialog;
	private versionChangedPending = false;
	private versionDialogOpen = false;
	private drawerSub?: Subscription;

	constructor(
		private dialogService: AppDialogService,
		private drawerService: AppDrawerService,
		private versionService: VersionService,
	) {
	}

	public ngOnInit(): void {
		this.drawerSub = this.drawerService.entries$.subscribe(() => {
			if (this.versionChangedPending && !this.drawerService.hasOpenDrawer()) {
				this.openVersionDialog();
			}
		});

		this.versionService.getVersion().subscribe((data) => {
			if (!data?.version) {
				return;
			}
			this.version = data.version;
			setInterval(() => {
				this.versionService.getVersion().subscribe((newData) => {
					const newVersion = newData?.version;
					if (newVersion && this.version !== newVersion) {
						this.version = newVersion;
						this.requestVersionDialog();
					}
				});
			}, 10000);
		});
	}

	public ngOnDestroy(): void {
		this.drawerSub?.unsubscribe();
	}

	private requestVersionDialog(): void {
		if (this.drawerService.hasOpenDrawer()) {
			this.versionChangedPending = true;
			return;
		}
		this.openVersionDialog();
	}

	private openVersionDialog(): void {
		if (this.versionDialogOpen) {
			return;
		}
		this.versionChangedPending = false;
		this.versionDialogOpen = true;
		const modale = this.dialogService.open(this.dialog);
		modale.onClose.subscribe(() => {
			window.location.reload();
		});
	}

	public getVersion(): any {
		return this.version;
	}
}
